import { Exclude, Expose, Transform } from "class-transformer";
import { IsEmail, IsOptional, IsString, IsUUID } from "class-validator";

@Exclude()
export class DynamicFormFieldsValues {
    @IsEmail()
    @IsOptional()
    @Transform((value: string) => value?.trim())
    @Expose()
    public email?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public businessName?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public firstName?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public lastName?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public birthdayAt?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public address?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public headquartersAddress?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public bankAccountCountryId?: string;

    @IsUUID("4")
    @IsOptional()
    @Transform((value: string) => value?.trim())
    @Expose()
    public nationalityCountryId?: string;

    @IsUUID("4")
    @IsOptional()
    @Transform((value: string) => value?.trim())
    @Expose()
    public residenceCountryId?: string;

    @IsUUID("4")
    @IsOptional()
    @Transform((value: string) => value?.trim())
    @Expose()
    public taxResidenceCountryId?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public annualIncomeRangeInEuro?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public companyIdNumber?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public taxIdentificationNumber?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public vatNumber?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public identifiedPersonNumber?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public occupation?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public uboDeclaration?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public invoiceCountryId?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public birthplace?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public basedIn?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public transportCountries?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public correspondenceAddress?: string;
}
